import React, { useState, useMemo, useEffect, useCallback } from 'react';

import LoaderComponent from '@/components/LoaderComponent';
import { BRAND_ACTIVITY_DATA } from '@/features/buyer-activity/utils/helper';
import BuyerActivityCard from '@/features/buyer-activity/components/BuyerActivityCard';
import CommonImage from '@/components/CommonImage';

const BrandActivity = () => {
	const [searchTerm, setSearchTerm] = useState('');
	const [visibleItems, setVisibleItems] = useState(12);
	const [isLoading, setIsLoading] = useState(false);
	const itemsPerPage = 12;

	const handleBuyerClick = (mixpanelUrl) => {
		window.open(mixpanelUrl, '_blank');
	};

	const filteredBrands = useMemo(() => {
		if (!searchTerm.trim()) {
			return BRAND_ACTIVITY_DATA;
		}
		return BRAND_ACTIVITY_DATA.filter((brand) =>
			brand.name.toLowerCase().includes(searchTerm.trim().toLowerCase())
		);
	}, [searchTerm]);

	const currentBrands = useMemo(() => {
		return filteredBrands.slice(0, visibleItems);
	}, [filteredBrands, visibleItems]);

	const handleSearchChange = (e) => {
		setSearchTerm(e.target.value);
		setVisibleItems(12);
	};

	const loadMoreItems = useCallback(async () => {
		if (visibleItems < filteredBrands.length && !isLoading) {
			setIsLoading(true);
			await new Promise((resolve) => setTimeout(resolve, 1000));
			setVisibleItems((prev) => Math.min(prev + itemsPerPage, filteredBrands.length));
			setIsLoading(false);
		}
	}, [visibleItems, filteredBrands.length, itemsPerPage, isLoading]);

	const handleScroll = useCallback(() => {
		if (
			window.innerHeight + document.documentElement.scrollTop >=
			document.documentElement.offsetHeight - 100
		) {
			loadMoreItems();
		}
	}, [loadMoreItems]);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [handleScroll]);

	useEffect(() => {
		setVisibleItems(12);
	}, [searchTerm]);

	return (
		<LoaderComponent loading={isLoading}>
			<div className="top-header assets-top-filter">
				<div className="page-title-area d-flex justify-content-between align-items-center pb-2">
					<h1 className="semibold-16">Brands activity</h1>
					<div>
						<div className="form-group size32 m-0 search-filter filter-with-animation">
							<div className={`with-icon right-icon`}>
								<input
									type="text"
									placeholder={'Search brands...'}
									name="name"
									autoComplete="off"
									value={searchTerm}
									onChange={handleSearchChange}
								/>
								<span className="right-icon">
									<CommonImage src={'/icons/search.svg'} alt="search" />
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="body-content">
				{searchTerm && (
					<div className="mb-3">
						<p className="text-muted mb-0">
							Found {filteredBrands.length} brand{filteredBrands.length !== 1 ? 's' : ''}
							{searchTerm && ` matching "${searchTerm}"`}
						</p>
					</div>
				)}

				<div className="buyer-activity-container d-grid gap-4 pt-2">
					{currentBrands.map((buyer, index) => (
						<BuyerActivityCard key={index} buyer={buyer} onClick={handleBuyerClick} />
					))}
				</div>

				{filteredBrands.length === 0 && searchTerm && (
					<div className="text-center py-5">
						<p className="text-muted mb-0">No brands found matching "{searchTerm}"</p>
					</div>
				)}
			</div>
		</LoaderComponent>
	);
};

export default BrandActivity;
